import React from 'react';
import Assets from '../../Assets/Assets';
import Sidebar from '../Sidebar/Sidebar';
import Header from '../Header/Header';
import Appcontent from './Appcontent';




function DefaultLayout() {


 


    return (
        <div className="dashboard-layout">

            <Sidebar logo={Assets?.Logo} />
            <div className="main-content">
                <Header
                    logo={Assets?.Logo}
                    userName="John Doe"
                    profilePhoto={Assets?.Login_b}
                />
                <div className="contents" style={{ textAlign: "start", paddingLeft: "19%", paddingTop: "6%" }}>
                    <Appcontent />
                </div>
            </div>
        </div>
    );
}

export default DefaultLayout;
